import { render, staticRenderFns } from "./ServiceComponent.vue?vue&type=template&id=2c2bcf9a&scoped=true"
import script from "./ServiceComponent.vue?vue&type=script&lang=js"
export * from "./ServiceComponent.vue?vue&type=script&lang=js"
import style0 from "./ServiceComponent.vue?vue&type=style&index=0&id=2c2bcf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2bcf9a",
  null
  
)

export default component.exports